import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  flex-direction: column;
  gap: 30px;
`;

export const Text = styled.div`
  font-size: 20px;
  max-width: 525px;
  text-align: center;
`;
